import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import type { ProgrammeEmailScheduleConfigRes } from '@dealstack/shared/lib/backendClient';
import { CONFIG_CARD_FORM_FIELDS } from './ConfigCard.types';
import type { ConfigCardFormValues } from './ConfigCard.types';

export const configCardFormSchema = z.object({
	[CONFIG_CARD_FORM_FIELDS.enabled]: z.boolean(),
	[CONFIG_CARD_FORM_FIELDS.initialDelayDays]: z
		.number({ invalid_type_error: 'Required' })
		.int()
		.min(0),
	[CONFIG_CARD_FORM_FIELDS.intervalDays]: z
		.number({ invalid_type_error: 'Required' })
		.int()
		.min(1),
	[CONFIG_CARD_FORM_FIELDS.maxFires]: z.number({ invalid_type_error: 'Required' }).int().min(1),
	[CONFIG_CARD_FORM_FIELDS.endDate]: z.date().nullable(),
});

export const useConfigCardForm = (config: ProgrammeEmailScheduleConfigRes) => {
	return useForm<ConfigCardFormValues>({
		mode: 'onChange',
		defaultValues: {
			[CONFIG_CARD_FORM_FIELDS.enabled]: config.enabled,
			[CONFIG_CARD_FORM_FIELDS.initialDelayDays]: config.initialDelayDays,
			[CONFIG_CARD_FORM_FIELDS.intervalDays]: config.intervalDays,
			[CONFIG_CARD_FORM_FIELDS.maxFires]: config.maxFires,
			[CONFIG_CARD_FORM_FIELDS.endDate]: config.endDate ? new Date(config.endDate) : null,
		},
		resolver: zodResolver(configCardFormSchema),
	});
};
